export default function Gallery() {
  const photos = [
    {
      alt: "Fenêtre oscillo-battant bloquée en position inclinée à Strasbourg",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/331449d79b2de3feb0e3a93000c0e561.jpeg",
      w: 600,
      h: 400,
      seq: "ob1",
    },
    {
      alt: "Technicien débloquant une fenêtre oscillo-battant à Schiltigheim, Bas-Rhin",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/713016d90088f17665582b4468404bd6.webp",
      w: 600,
      h: 400,
      seq: "ob2",
    },
    {
      alt: "Déblocage mécanisme anti-fausse manœuvre à Haguenau",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/1a62be410fa56940e3cc93919e661108.png",
      w: 600,
      h: 400,
      seq: "ob3",
    },
    {
      alt: "Compas de manœuvre usé sur une fenêtre bloquée à Strasbourg",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/e8838c6c034fe2f6e3242931acf07e01.jpeg",
      w: 600,
      h: 400,
      seq: "ob4",
    },
    {
      alt: "Technicien DF PRO vérifiant le déblocage à Illkirch",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/6d237f782373e8b9b4c897af9248880c.webp",
      w: 600,
      h: 400,
      seq: "ob5",
    },
    {
      alt: "Fenêtre oscillo-battant débloquée et fonctionnelle dans le Bas-Rhin",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/4f5ebbcb84a72fdd78cd48d354b38b1d.webp",
      w: 600,
      h: 400,
      seq: "ob6",
    },
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Galerie de réalisations
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum">
            Nos <span className="font-serif italic">interventions</span> de déblocage
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {photos.map((p) => (
            <div key={p.seq} className="rounded-2xl overflow-hidden border border-rose-200 bg-rose-50">
              <img
                src={
                  p.src
                    ? p.src
                    : `https://readdy.ai/api/search-image?query=${encodeURIComponent(p.prompt!)}&width=${p.w}&height=${p.h}&seq=${p.seq}&orientation=landscape`
                }
                alt={p.alt}
                className="w-full h-[260px] object-cover object-top"
              />
              <div className="px-4 py-3">
                <p className="text-xs text-plum-dark/60 italic">{p.alt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}